import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';

export const adminAnsweringSchema = (state = {
    correlationId: null,
    isAnsweringSchemaLoading: false,
    isAnsweringSchemaCreating: false,
    answeringSchemaSubmittedAndShouldRedirect: false,
    initWithOldData: false,
    created: false,
    AnsweringSchema: {},
    AnsweringSchemaOptions: [],
    availableName: true,
}, action) => {
    switch (action.type) {
        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_REDIRECT_RESET:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_REDIRECT_RESET: {
            return Object.assign({}, state, {
                answeringSchemaSubmittedAndShouldRedirect: false,
            });
        }
        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_RESET:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_RESET: {
            return Object.assign({}, state, {
                correlationId: null,
                isAnsweringSchemaLoading: false,
                isAnsweringSchemaCreating: false,
                answeringSchemaSubmittedAndShouldRedirect: false,
                initWithOldData: false,
                created: false,
                AnsweringSchema: {},
                availableName: true
            });
        }
        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_UPDATE_PENDING:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_UPDATE_PENDING:
        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_CREATE_PENDING:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_CREATE_PENDING: {
            return Object.assign({}, state, {
                isAnsweringSchemaCreating: true,
                isAnsweringSchemaLoading: true,
                answeringSchemaSubmittedAndShouldRedirect: true,
            });
        }

        case techDocWebsocketCommands.TECH_DOC_SOLUTION_GROUPS_ACCEPTED:
        case sparePartsWebsocketCommands.SPARE_PARTS_SOLUTION_GROUPS_ACCEPTED: {
            const { correlationId } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isAnsweringSchemaCreating: false,
                created: true,
                isAnsweringSchemaLoading: true,
                correlationId
            });
        }

        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_SEND:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_SEND: {
            const { correlationId, answeringSchema, error } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            if (error) {
                return Object.assign({}, state, { isAnsweringSchemaLoading: false, correlationId });
            }

            return Object.assign({}, state, {
                isAnsweringSchemaLoading: false,
                correlationId,
                answeringSchema
            });
        }

        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_SEND_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_SEND_ERROR: {
            const { correlationId } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isAnsweringSchemaCreating: false,
                isAnsweringSchemaLoading: false,
                correlationId,
            });
        }

        case techDocWebsocketCommands.TECH_DOC_SOLUTION_GROUPS_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_SOLUTION_GROUPS_ERROR: {
            const { correlationId } = action.payload;

            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isAnsweringSchemaCreating: false,
                created: false,
                isAnsweringSchemaLoading: false,
                answeringSchemaSubmittedAndShouldRedirect: false,
                initWithOldData: true,
                correlationId,
            });
        }

        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_DETAIL_FETCH_PENDING:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_DETAIL_FETCH_PENDING: {
            return Object.assign({}, state, { isAnsweringSchemaLoading: true });
        }

        case techDocWebsocketCommands.TECH_DOC_ADMIN_SOLUTION_GROUPS_SEND:
        case sparePartsWebsocketCommands.SPARE_PARTS_ADMIN_SOLUTION_GROUPS_SEND:{
            const { solutionGroups } = action.payload;
            return Object.assign({}, state, { AnsweringSchemaOptions: solutionGroups });
        }

        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_SAVE_NEW_ERROR:
        case techDocWebsocketCommands.TECH_DOC_ANSWERING_SCHEMA_SAVE_UPDATE_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_SAVE_NEW_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_ANSWERING_SCHEMA_SAVE_UPDATE_ERROR: {
            return Object.assign({}, state, { isAnsweringSchemaLoading: false });
        }

        default:
            return state;
    }
};
